import { makeProxyRequest } from "./api";

////////////////////////////////////////////////////////////////////

export interface ConversationType {
  callback_url: string;
  conversation_id: string;
  conversation_name: string;
  conversation_url: string;
  created_at: string;
  status: string;
}

export async function startConversation(
  roomId: string,
): Promise<ConversationType | null> {
  try {
    const response = await makeProxyRequest("api/avatar/start_conversation", "POST", {room_id: roomId});
    if (!response.ok) {
      console.error(`Failed to start conversation: ${response.statusText}`);
      return null;
    }
    const data = await response.json();
    return data?.conversation_data ?? null;
  } catch (error) {
    console.error('An error occurred in startConversation:', error);
    return null;
  }
}
